import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { makeGetTheme } from '../selectors/app-props';

import { createLoader } from '../utils';
import config from '../config';

import AnchorUrlPreview from './anchor-url-preview';
import AppBar from 'components/AppBar';

import ThemeProvider from '../context/ThemeProvider';

import Sockets from '../sockets';

import ModalPlaceholder from './placeholders/modal.placeholder';

const ModalRoot = createLoader('ModalRootChunk', () => import(/* webpackChunkName: "ModalRootChunk"*/ '../modals/modal-root'), <ModalPlaceholder />);

class AppRoot extends PureComponent {
    componentDidUpdate(prevProps) {
        if (prevProps.theme !== this.props.theme) {
            document.body.classList.remove(`nifty-theme-${prevProps.theme}`);
            document.body.classList.add(`nifty-theme-${this.props.theme}`);
        }
    }

    componentDidMount() {
        document.body.classList.add(`nifty-theme-${this.props.theme}`);
    }

    componentWillUnmount() {
        document.body.classList.remove(`nifty-theme-${this.props.theme}`);
    }

    render() {
        return (
            <React.Fragment>
                <AppBar history={this.props.router} />

                <div className="app-inner">
                    <Sockets host={config.SOCKET_HOST}>
                        <ThemeProvider theme={this.props.theme}>
                            { this.props.children }

                            {
                                this.props.modal.modalType ? (
                                    <ModalRoot modalType={this.props.modal.modalType} modalProps={this.props.modal.modalProps} />
                                ) : null
                            }

                            <AnchorUrlPreview />
                        </ThemeProvider>
                    </Sockets>
                </div>
            </React.Fragment>
        );
    }
}

const makeMapStateToProps = () => {
    const getTheme = makeGetTheme();

    return ({ modal, appProps }) => ({
        modal,
        theme: getTheme(appProps)
    });
};

export default connect(makeMapStateToProps)(AppRoot);
